export default (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M18 18L6 6" stroke="#404040" stroke-width="1.5" stroke-linecap="round" />
  </svg>
);
